import { useMemo } from 'react'
import { getAreasData } from 'helpers'
import type { IArea } from 'interfaces/areas'

const useAreasList = (selectedArea: IArea, dataSource: IArea[]): IArea[] =>
  useMemo(() => {
    if (selectedArea?.id === undefined || dataSource.length < 1) {
      return []
    }

    return getAreasData(
      selectedArea.parentId,
      [selectedArea],
      dataSource,
    ).reverse()
  }, [dataSource, selectedArea])

const useLargeNamesIds = (areas: IArea[]): string[] =>
  useMemo(() => {
    if (areas.length < 1) {
      return []
    }

    const elements = document.getElementsByClassName(
      'areaSelector-breadcrumb-item',
    )

    return Array.prototype.filter
      .call(
        elements,
        (element: HTMLElement) => element.offsetWidth < element.scrollWidth,
      )
      .map((element: HTMLElement) => element.id)
  }, [areas])

export { useAreasList, useLargeNamesIds }
